import { FEATURE_SOURCE } from 'components/MapBox/hooks/useLayers/layers/constants';

export const CLUSTER_FEATURE_SOURCE = FEATURE_SOURCE.CLUSTER;

export { STATIC_ZOOM } from 'components/MapBox/hooks/useLayers/layers/constants';

export const CLUSTERS_RADIUS = 50;

export const OFFSET_MAP_CENTER: [number, number] = [0, -200];

export { MAP_LAYER } from 'components/Map/constants';

export { FIT_TO_DATA_PADDING } from '../useBounds/constants';
